import { Icon, Input, Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { MAX_ADDITIONAL_THOUGHTS_LENGTH } from '@hero/constants';
import { useRecognitionReachOutSupport } from '@hero/services';
import { useNotification } from '@hero/store/hooks';
import { cleanObjectEmptyFields } from '@hero/utils';

import * as S from './style';

function ContactBGSModal({ recognitionCode, onSendSuccessfully, isModalOpen, onModalOpen }) {
  const { t } = useTranslation();
  const { mutateAsync: reachOutSupport, isLoading } = useRecognitionReachOutSupport();
  const { showSuccess } = useNotification();

  const [additionalMessage, setAdditionalMessage] = React.useState('');

  const Content = (
    <S.ContactBGSModal>
      <S.ImageContainer>
        <Icon name="phone" style={{ width: 80, maxWidth: 80, height: 80, maxHeight: 80 }} />
      </S.ImageContainer>
      <Typography style={{ textAlign: 'center', margin: '16px 0' }} variant="h4">
        {t('letsConnectTailoredSolution')}
      </Typography>
      <S.Description variant="body2">
        <Trans i18nKey="letsConnectTailoredSolutionDesc" components={{ b: <b /> }} />
      </S.Description>
      <S.ExtraDescription variant="body2" color="neutral" emphasis="500">
        <Trans i18nKey="letsConnectTailoredSolutionExtra" />
      </S.ExtraDescription>
      <Input
        variant="outlined"
        label={t('includeAdditionalNotes')}
        value={additionalMessage}
        inputProps={{ maxLength: MAX_ADDITIONAL_THOUGHTS_LENGTH }}
        onChange={e => setAdditionalMessage(e.target.value)}
        helperProps={{
          showCounter: true
        }}
      />
    </S.ContactBGSModal>
  );

  return (
    <>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={onModalOpen}
        primaryButtonProps={{
          children: t('yCallMe'),
          onClick: async () => {
            await reachOutSupport({
              params: {
                code: recognitionCode
              },
              body: cleanObjectEmptyFields({
                reason: 'contact-limit-with-credit-card',
                description: additionalMessage
              })
            });
            onModalOpen(false);
            showSuccess({
              message: t('ourSalesTeamWillCallYou'),
              type: 'toast'
            });
            setAdditionalMessage('');
            if (onSendSuccessfully) onSendSuccessfully();
          },
          disabled: isLoading,
          loading: isLoading
        }}
        secondaryButtonProps={{
          children: t('nImFine')
        }}
        size="sm"
      >
        {Content}
      </Modal>
    </>
  );
}

export { ContactBGSModal };
